<template>
  <div class="big">
    <div class="page_title">H5转换器模块配置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>应用端</span>
            <el-select
              v-model="from"
              placeholder="请选择"
              style="width: 160px; margin: 0 20px 0 10px"
              @change="search"
            >
              <el-option
                label="全部"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in from_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span>页面名称</span>
            <el-input
              v-model="page_name"
              style="width: 160px; margin: 0 20px 0 10px"
              @change="search"
              clearable
            ></el-input>
            <span>短链</span>
            <el-input
              v-model="short_link"
              style="width: 160px; margin: 0 20px 0 10px"
              @change="search"
              clearable
            ></el-input>
            <span>创建日期</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 225px; margin: 0 12px"
              @change="search"
            ></el-date-picker>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981"
              @click="search"
            >查询</el-button>
          </div>
          <el-button
            type="primary"
            @click="AddRoute"
            style="width: 120px"
            :disabled="
                  module_id_array[0] ? !module_id_array.includes('1062') : false
                "
          >新增配置</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="id"
              label="序号"
              width="70"
            ></el-table-column>
            <el-table-column
              label="应用端"
              width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.from==1">商城小程序</span>
                <span v-if="scope.row.from==2">患者小程序</span>
                <span v-if="scope.row.from==3">用户app</span>
                <span v-if="scope.row.from==4">医生app</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="page_name"
              label="跳转页面名称"
            ></el-table-column>
            <el-table-column label="页面路径">
              <template slot-scope="scope">
                <div v-if="scope.row.from==1||scope.row.from==2">
                  {{scope.row.page_route}}
                </div>
                <div v-if="scope.row.from==3||scope.row.from==4">
                  <div>
                    IOS：{{scope.row.ios_page_route}}
                  </div>
                  <div>
                    Android：{{scope.row.android_page_route}}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="route_parameter"
              label="参数"
            ></el-table-column>
            <el-table-column
              prop="url_string"
              label="链接"
            ></el-table-column>
            <el-table-column
              prop="short_link"
              label="短链"
            ></el-table-column>
            <el-table-column
              prop="desc"
              label="说明"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="更新日期"
              width="100"
            ></el-table-column>
            <el-table-column
              label="状态"
              width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status">生效中</span>
                <span
                  v-else
                  style="color: #e53528"
                >已作废</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status"
                  @click="editRoute(scope.row)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('1063') : false
                  "
                >编辑</el-button>
                <el-button
                  @click="editStatus(scope.row.id, 0)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('1064') : false
                  "
                >作废</el-button>
                <el-button
                  @click="editStatus(scope.row.id, 1)"
                  type="text"
                  size="medium"
                  v-if="!scope.row.status"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('1064') : false
                  "
                >恢复</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="addroute"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="应用端"
            prop="from"
          >
            <el-select
              v-model="ruleForm.from"
              placeholder="请选择"
              style="width: 200px;"
            >
              <el-option
                v-for="item in from_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="跳转页面名称"
            prop="page_name"
          >
            <el-input
              v-model="ruleForm.page_name"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="页面路径"
            prop="page_route"
            v-if="ruleForm.from==1||ruleForm.from==2"
          >
            <el-input v-model="ruleForm.page_route"></el-input>
          </el-form-item>
          <el-form-item
            label="ios页面路径"
            prop="ios_page_route"
            v-if="ruleForm.from==3||ruleForm.from==4"
          >
            <el-input v-model="ruleForm.ios_page_route"></el-input>
          </el-form-item>
          <el-form-item
            label="android页面路径"
            prop="android_page_route"
            v-if="ruleForm.from==3||ruleForm.from==4"
          >
            <el-input v-model="ruleForm.android_page_route"></el-input>
          </el-form-item>
          <el-form-item label="参数">
            <el-input v-model="ruleForm.route_parameter"></el-input>
          </el-form-item>
          <el-form-item
            label="短链"
            prop="short_link"
          >
            <el-input v-model="ruleForm.short_link"></el-input>
          </el-form-item>
          <el-form-item
            label="说明"
            prop="desc"
          >
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="ruleForm.desc"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: left; padding: 50px 0 20px 130px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
          >保 存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from '../../../api/system';
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      from: '',
      page_name: '',
      short_link: '',
      date: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      roleList: [],
      user_name: '',
      is_crm: '',
      addroute: false,
      title: '添加用户',
      ruleForm: {
        from: '',
        page_name: '',
        page_route: '',
        ios_page_route: '',
        android_page_route: '',
        route_parameter: '',
        short_link: '',
        desc: ''
      },
      rules: {
        from: [
          {
            required: true,
            message: '请选择应用端',
            trigger: 'blur'
          }
        ],
        page_name: [
          { required: true, message: '请输入跳转页面名称', trigger: 'blur' }
        ],
        page_route: [
          { required: true, message: '请输入页面路径', trigger: 'blur' }
        ],
        ios_page_route: [
          { required: true, message: '请输入页面路径', trigger: 'blur' }
        ],
        android_page_route: [
          { required: true, message: '请输入页面路径', trigger: 'blur' }
        ]
      },
      from_list: [
        {
          label: '商城小程序',
          value: 1
        },
        {
          label: '患者小程序',
          value: 2
        },
        {
          label: '用户app',
          value: 3
        },
        {
          label: '医生app',
          value: 4
        }
      ]
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取用户列表
    getList() {
      let data = {
        from: this.from,
        page_name: this.page_name,
        short_link: this.short_link,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios.post('platform/Admin/routeConfigList', data).then((res) => {
        if (res.code == 0) {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list.map((item) => {
            item.update_time = dayjs
              .unix(item.update_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //添加用户按钮
    AddRoute() {
      this.title = '新增';
      this.ruleForm = {
        from: '',
        page_name: '',
        page_route: '',
        ios_page_route: '',
        android_page_route: '',
        route_parameter: '',
        short_link: '',
        desc: ''
      };
      this.addroute = true;
    },
    //添加/编辑 用户
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title == '新增') {
            let data = this.ruleForm;
            this.axios
              .post('platform/admin/addRouteConfig', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('添加成功');
                  this.addroute = false;
                  this.getList();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            let data = this.ruleForm;
            this.axios
              .post('platform/admin/updateRouteConfig', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('修改成功');
                  this.addroute = false;
                  this.getList();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //编辑
    editRoute(row) {
      this.title = '编辑';
      this.ruleForm = {
        id: row.id,
        from: row.from,
        page_name: row.page_name,
        page_route: row.page_route,
        ios_page_route: row.ios_page_route,
        android_page_route: row.android_page_route,
        route_parameter: row.route_parameter,
        short_link: row.short_link,
        desc: row.desc
      };
      this.addroute = true;
    },
    //作废 恢复
    editStatus(id, status) {
      if (!status) {
        this.$confirm(
          '作废后页面将不能再进行跳转哦，请谨慎操作！',
          '提示消息',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }
        )
          .then(() => {
            this.axios
              .post('platform/admin/updateRouteConfigStatus', { id, status })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('状态已修改');
                  this.getList();
                }
              });
          })
          .catch(() => {});
      } else {
        this.axios
          .post('platform/admin/updateRouteConfigStatus', { id, status })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('状态已修改');
              this.getList();
            }
          });
      }
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
  text-align: left;
}
</style>